module.exports = __webpack_public_path__ + "static/media/Ground-Left.54008254.webp";